export const DEFAULT_POI_MARKER_COLOR = '#fa7d00';

export const POI_MARKER_FILL = '__POI_MARKER_FILL__';

export function normalizePoiMarkerColor(color: string): string {
  if (color == null || color.trim() === '') {
    return DEFAULT_POI_MARKER_COLOR;
  }
  let normalized = color.trim();
  if (normalized.charAt(0) !== '#' && normalized.indexOf('rgb') !== 0) {
    normalized = '#' + normalized;
  }
  if (normalized.length === 4) {
    normalized = '#' + normalized.charAt(1) + normalized.charAt(1)
      + normalized.charAt(2) + normalized.charAt(2)
      + normalized.charAt(3) + normalized.charAt(3);
  }
  return normalized;
}

export function applyPoiMarkerFill(svg: string, color: string): string {
  return svg.split(POI_MARKER_FILL).join(normalizePoiMarkerColor(color));
}

export function hexToRGBA(hex: string, opacity: number = 1): string {
  let r = '0x' + hex[1] + hex[2];
  let g = '0x' + hex[3] + hex[4];
  let b = '0x' + hex[5] + hex[6];

  return `rgb(${+r},${+g},${+b},${opacity})`;
}
